import { Badge, Flex, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../Components/Button"
import Icon from "../../../Icon"
import Images from "../../../Images"
import { statusTextMap, tagColorMap, tagMap } from "../../../Utils/utils"

dayjs.extend(utc)

const { Text } = Typography

const InvoiceHistoryCard = ({ record, theme, onDownload, isAdmin, externalDemoMode }) => {
  const { t } = useTranslation()

  const statusLabel = statusTextMap[record?.status] || record?.status
  const dateStr = record?.date ? dayjs(record.date).format("DD MMM, YYYY h:mmA") + " (UTC)" : "—"
  const amount =
    record?.invoice_amount != null ? `${record?.currency || "$"} ${record.invoice_amount}` : "—"
  const canDownload = !isAdmin && ["Paid", "Failed", "Declined"].includes(record?.status)
  const renderBalanceValue = (value) => {
    return value != null ? `$ ${value}` : "—"
  }

  return (
    <div className="invoice-history-card">
      <div className="invoice-history-card__badge">
        <Badge
          status={tagMap[record?.status?.toLowerCase()] || "default"}
          color={tagColorMap[record?.status]}
        />
        <Text style={{ fontSize: 14, fontWeight: 500, letterSpacing: "-0.3px" }}>
          {statusLabel}
        </Text>
      </div>

      <div className="invoice-history-card__row">
        <div className="invoice-history-card__field">
          <span className="invoice-history-card__label">{t("Date")}</span>
          <Text className="invoice-history-card__value invoice-history-card__value--ellipsis">
            {dateStr}
          </Text>
        </div>
        <div className="invoice-history-card__field">
          <span className="invoice-history-card__label">{t("Amount")}</span>
          <Text className="invoice-history-card__value">{amount}</Text>
        </div>
      </div>

      <div className="invoice-history-card__row">
        <div className="invoice-history-card__field">
          <span className="invoice-history-card__label">{t("Payment method")}</span>
          {record?.brand ? (
            <Flex align="center" gap={6}>
              <img
                src={Images[`${record.brand.toLowerCase()}${theme === "dark" ? "_dark" : ""}`]}
                width={20}
                height={20}
                alt={record.brand}
              />
              <Text className="invoice-history-card__value">
                {"•••• " + (record?.card_last4 || "")}
              </Text>
            </Flex>
          ) : (
            <Text className="invoice-history-card__value">—</Text>
          )}
        </div>
        <div className="invoice-history-card__field">
          <span className="invoice-history-card__label">{t("Paid with")}</span>
          <Text className="invoice-history-card__value">{record?.paid_with || "—"}</Text>
        </div>
      </div>

      <div className="invoice-history-card__row">
        <div className="invoice-history-card__field">
          <span className="invoice-history-card__label">{t("Type")}</span>
          <Text className="invoice-history-card__value">{record?.type || "—"}</Text>
        </div>
        <div className="invoice-history-card__field">
          <span className="invoice-history-card__label">{t("Transaction ID")}</span>
          <Text className="invoice-history-card__value">{record?.id || "—"}</Text>
        </div>
      </div>

      <div className="invoice-history-card__row">
        <div className="invoice-history-card__field">
          <span className="invoice-history-card__label">{t("Balance Before")}</span>
          <Text className="invoice-history-card__value">
            {renderBalanceValue(record?.balance_before)}
          </Text>
        </div>
        <div className="invoice-history-card__field">
          <span className="invoice-history-card__label">{t("Balance After")}</span>
          <Text className="invoice-history-card__value">
            {renderBalanceValue(record?.balance_after)}
          </Text>
        </div>
      </div>

      {canDownload && (
        <ButtonComponent
          style={{ width: "100%" }}
          icon={<Icon type="arrow_inbox" />}
          onClick={() => onDownload(record)}
          disabled={externalDemoMode}
        >
          {t("Export")}
        </ButtonComponent>
      )}
    </div>
  )
}

export default InvoiceHistoryCard
